import { render, staticRenderFns } from "./Modal-content.vue?vue&type=template&id=da16f6a0&scoped=true&lang=pug"
import script from "./Modal-content.vue?vue&type=script&lang=js"
export * from "./Modal-content.vue?vue&type=script&lang=js"
import style0 from "./Modal-content.vue?vue&type=style&index=0&id=da16f6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da16f6a0",
  null
  
)

export default component.exports